import { render, staticRenderFns } from "./creator-v3-room-people-management.vue?vue&type=template&id=51176a16"
import script from "./creator-v3-room-people-management.js?vue&type=script&lang=js&external"
export * from "./creator-v3-room-people-management.js?vue&type=script&lang=js&external"
import style0 from "./creator-v3-room-people-management.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports